// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"8f7881a5","488":"fe3bbb13"}[chunkId] + ".chunk.js";
};